// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const LinkOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M6.27 17.73a3.1 3.1 0 010-4.39l2.83-2.82-1.34-1.35L4.93 12A5 5 0 0012 19.07l2.83-2.83-1.35-1.34-2.82 2.83a3.1 3.1 0 01-4.39 0zm3.6-2.2l5.66-5.65-1.4-1.42-5.67 5.66 1.42 1.42zM12 4.94L9.17 7.76l1.34 1.34 2.83-2.83a3.1 3.1 0 014.39 4.39l-2.83 2.82 1.34 1.35L19.07 12A5 5 0 0012 4.93z","fill":"currentColor"}}]},"name":"link","theme":"outlined"};

const LinkOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={LinkOutlinedSvg} />;
  LinkOutlined.displayName = 'LinkOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(LinkOutlined);
